/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Features_Day_HelloInputs */

const en_features_day_hello = /** @type {(inputs: Features_Day_HelloInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hi, ${i?.name}`)
};

const pl_features_day_hello = /** @type {(inputs: Features_Day_HelloInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cześć, ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Hi, {name}" |
*
* @param {Features_Day_HelloInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_day_hello = /** @type {((inputs: Features_Day_HelloInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Day_HelloInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_day_hello(inputs)
	return en_features_day_hello(inputs)
});